import { Box, css } from '@mui/material';

import { CoverContentLayout, CoverLayout, Logo, Text } from '../layout';
import { useTranslation } from 'react-i18next';
import Markdown from '../../../ui/Markdown';


export const LastPage = () => {
  const { t } = useTranslation(['project']);
  return (
    <CoverLayout>
      <CoverContentLayout>
        <Box
          width="100%"
          height="100%"
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          <Box width="100%" paddingX="8%">
              <Markdown className="lastPageMarkdownClass">
                  {t('project:pdfExport.lastPage.text')}
              </Markdown>
          </Box>
          <Box height="5%" />
          <Box
            width="100%"
            paddingX="8%"
            display="flex"
            justifyContent="space-between"
          >
            <Text textAlign="justify" color="black" fontSize="30px">
              <b>{t('project:pdfExport.lastPage.email')}</b>
            </Text>
          </Box>
          <Box height="10%" />
          <Box width={'100%'} display="flex" justifyContent="center">
            <Logo
              src="/SONAR LOGO COMPACT - Capsule blanche - 2025.png"
              maxWidth="300px"
              maxHeight="150px"
            />
          </Box>
        </Box>
      </CoverContentLayout>
    </CoverLayout>
  );
};
